import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/nnpp/')({
  beforeLoad: () => {
    throw redirect({ to: '/nnpp/imports' })
  },
})
